import React from 'react';
import DocentesTable from './TableDocentes/TableDocentes';

const Docentes = () => {
  return <DocentesTable/> ;
};

export default Docentes;
